<template>
  <section class="specs">
    <div class="item" @click="changeShow">
      <span>已选</span>
      <span v-for="(item,index) in specs" :key="index">{{item.name}},</span>
      <span>{{number}}件(可选服务)</span>
      <van-icon name="arrow" class="item-right"/>
    </div>
    <van-popup v-model="show" position="bottom">
      <div class="specs-box">
        <div class="specs-title">选择新机机型</div>
        <div class="specs-content">
          <div
            class="image"
            :style="'background:url('+product.img+') no-repeat;background-size:100%'"
          ></div>
          <div class="info">
            <p>{{product.title}}</p>
            <p>
              <span>¥</span>
              {{parseInt(product.price)+parseInt(specs[0].price)+parseInt(specs[1].price)}}
            </p>
          </div>
        </div>
        <div class="specs-list">
          <div class="item" v-for="(item,index) in product.attr" :key="index">
            <div class="specs-item-label">{{item.attr_name}}</div>
            <div class="specs-item-value">
              <span
                v-for="value in item.attr_value"
                :class="specs[index]&&specs[index]['value']==value.attr_value_id?'active':''"
                :key="value.attr_value_id"
                @click="onClick(value,index)"
              >{{value.attr_value_name}}</span>
            </div>
          </div>
        </div>
        <div class="number clearfix">
          <p>选择数量</p>
          <p>
            <van-stepper v-model="number" :max="product.goods_number" @change="handleChange"/>
          </p>
        </div>
        <van-button icon="star-o" class="specs-btn" type="danger" @click="changeShow(false)">确定</van-button>
      </div>
    </van-popup>
  </section>
</template>

<script>
export default {
  props: ["product", "specs"],
  data() {
    return {
      number: 1,
      show: false
    };
  },
  methods: {
    handleChange(value) {
      this.$emit("changeNumber", value);
    },
    changeShow(value) {
      console.log(value);
      this.show = !this.show;
      // this.$emit("changeShow", value);
    },
    onClick(item, index) {
      let data = {
        value: item.attr_value_id,
        name: item.attr_value_name,
        price: item.attr_price
      };
      if (this.specs[index] === undefined) {
        this.specs.push(data);
      } else {
        this.specs.splice(index, 1, data);
      }
      this.$emit("changeSpecs", this.specs);
    }
  }
};
</script>

<style scoped>
.specs {
  margin: 1px auto 0.05rem;
  padding: 0.17rem 0.14rem;
  background: #fff;
}
.specs .item {
  position: relative;
}
.specs .item span:nth-child(1) {
  color: #999;
  margin-right: 0.17rem;
}
.specs .item span:nth-child(2) {
  color: #333;
}
.specs .item-right {
  font-size: 0.18rem;
  position: absolute;
  color: #888;
  right: 0rem;
  top: 0rem;
}
.specs .van-popup {
  background: none;
}
.specs .specs-box {
  border-top-right-radius: 0.05rem;
  border-top-left-radius: 0.05rem;
  background: #fff;
  padding: 0.18rem 0.12rem 0.09rem;
}
.specs .specs-box .specs-title {
  text-align: center;
  margin-bottom: 0.1rem;
  font-size: 0.15rem;
}
.specs .specs-box .specs-content {
  display: flex;
}
.specs .specs-box .specs-content p:nth-child(1) {
  font-size: 0.14rem;
  line-height: 0.2rem;
  height: 0.5rem;
  color: #666;
  margin-top: 0.1rem;
}
.specs .specs-box .specs-content p:nth-child(2) {
  font-size: 0.2rem;
  color: #f44;
}
.specs .specs-box .specs-content p:nth-child(2) span {
  font-size: 0.14rem;
}
.specs .specs-box .image {
  width: 0.9rem;
  height: 0.9rem;
  background-size: 100%;
  margin-right: 0rem;
}
.specs .specs-box .specs-list {
  margin-top: 0.17rem;
  width: 3.4rem;
}
.specs .specs-box .specs-list .specs-item-label {
  margin: 0.1rem 0;
  font-size: 0.15rem;
  color: #333;
}
.specs .specs-box .specs-list .specs-item-value span {
  display: inline-block;
  background:rgba(239,238,238,1);
border-radius:0.12rem;
  padding: 0.05rem 0.11rem;
  margin: 0.05rem 0.28rem 0.05rem 0;
  border-radius: 0.12rem;
  color: #333;
}
.specs .specs-box .specs-list .specs-item-value span.active {
  color: #F94C66;
  background: rgba(250, 223, 227, 1);
  border: 1px solid rgba(249, 76, 102, 1);
}
.specs .specs-box .number {
  margin: 0.2rem 0;
  
}
.specs .specs-box .number p:nth-child(1) {
  float: left;
  margin-top:0.05rem;
  color: #333;
}
.specs .specs-box .number p:nth-child(2) {
  float: right;
}
.specs .specs-box .specs-btn {
  width: 3.25rem;
  margin:0 auto;
  display: block;
  border-radius: 0.21rem;
  background: #F94C66;
  color: #fff;
  font-size: 0.15rem;
}
</style>
